import { TypedDocumentNode } from '@graphql-typed-document-node/core'
import { ClientError, GraphQLClient } from 'graphql-request'

import { ApiError, handleUnknownApiError } from './error'

const gqlClient = new GraphQLClient(
  `${import.meta.env.VITE_API_URL}/connect/query`,
  {
    mode: 'cors',
    credentials: 'include',
  },
)

export const graphqlRequest = async <
  Result,
  Variable extends Record<string, unknown>,
>(
  document: TypedDocumentNode<Result, Variable>,
  variable: Variable,
) => {
  try {
    return await gqlClient.request<Result>(document, variable)
  } catch (error) {
    const isExpectedError = error instanceof ClientError
    if (!isExpectedError) {
      throw handleUnknownApiError(error)
    }
    if (!error.response.errors || error.response.errors.length === 0) {
      throw new ApiError(error.message, {
        status: error.response.status,
        cause: error,
      })
    }
    // エラーがリストで返ってくるが、基本的には一つなので最初のエラーを取得する
    const firstError = error.response.errors[0]
    const status =
      'status' in firstError.extensions
        ? (firstError.extensions.status as number)
        : undefined
    throw new ApiError(firstError.message, {
      cause: error,
      status,
    })
  }
}
